import PropTypes from 'prop-types';
import React from 'react';
import ReviewSpinner from './ReviewSpinner';
import TestScoreViewer from '../../fields/TestScoreViewer';
import requiresReview from './hocs/requiresReview';
import { compose } from 'redux';
import { duckify, filterDuck } from '../../../utils/duckify';
import { testScores } from '../../../ducks';

/**
 * Displays contact test scores.
 *
 * @param params route params from react-router
 * @param testScores test score objects
 * @return {JSX.Element}
 */
const ReviewTestScores = ({ params, testScores }) => {
  const { contactId } = params;

  return (
    <div className="review-activities">
      <h2>Test Scores</h2>

      {!testScores.ready && <ReviewSpinner/>}

      {testScores.ready && <React.Fragment>
        {testScores.length !== 0 && <TestScoreViewer contactId={contactId}/>}

        {testScores.length === 0 && <div className="review-activities-none">
          <div className="alert alert-info">
            There are no test scores for this applicant.
          </div>
        </div>}
      </React.Fragment>}
    </div>
  );
};

ReviewTestScores.propTypes = {
  params: PropTypes.shape({
    contactId: PropTypes.string,
  }).isRequired,
  testScores: PropTypes.arrayOf(PropTypes.object),
};

const mapDucksToProps = ({ params }) => {
  const { contactId } = params;
  return {
    testScores: filterDuck(testScores, { contact_id: contactId })
  };
};

export default compose(
  requiresReview,
  duckify(mapDucksToProps)
)(ReviewTestScores);
